import { useCallback } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import BuyButton from '@Pages/PageFavorites/elements/BuyButton';
import ConstructorBuyButton from '@Pages/PageFavorites/elements/ConstructorBuyButton';
import AboutReceiptButton from '@Components/AboutReceiptButton';
import ButtonUI from '@UI/Button';
import styles from './Button.module.css';

import type { FC } from 'react';
import type { ProductData } from '@Types/Product';

interface ButtonProps {
  className?: string;
  product: ProductData;
}

const Button: FC<ButtonProps> = (props) => {
  const { className, product } = props;
  const { t } = useTranslation();
  const isComingSoon = product.status === 'ComingSoon';
  const isConstructor = product.isConstructor || product.isConfiguratorOnPage;
  const isConstructorButton = !isComingSoon && product.isActive && isConstructor;
  const isBuyButton = !isComingSoon && product.isActive && !isConstructor;
  const isDefaultButton = !isComingSoon && !product.isActive && !isConstructor;

  const handleClickNotifyAboutReceipt = useCallback(() => {
    ModalWindows.open('NotifyAboutReceipt', { product });
  }, [product]);

  return (
    <>
      {isComingSoon && (
        <AboutReceiptButton product={product} className={cn(styles.button, className)} />
      )}
      {isConstructorButton && (
        <ConstructorBuyButton product={product} className={cn(styles.button, className)} />
      )}
      {isBuyButton && (
        <BuyButton
          productId={product.id}
          product={product}
          className={cn(styles.button, className)}
        />
      )}
      {isDefaultButton && (
        <ButtonUI
          className={cn(styles.button, className)}
          wide
          theme='secondary'
          onClick={handleClickNotifyAboutReceipt}
        >
          {t('notify-about-receipt')}
        </ButtonUI>
      )}
    </>
  );
};

export default Button;
